// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2BARf","content":"styles_content__eA1_r","selectAll":"styles_selectAll__2y_So"};